"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var CurrencyInput_1 = __importDefault(require("CurrencyInput/CurrencyInput"));
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var PlanGroupTabs_1 = require("QuoteV2/Components/PlanGroupTabs");
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var react_1 = __importDefault(require("react"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var StringManipulater_1 = require("Utils/StringManipulater");
var VariablesCombobox_1 = __importDefault(require("./VariablesCombobox"));
var c = (0, BemBuilder_1.default)("plan-card-price-popover");
var PlanCardPricePopover = (function (_super) {
    __extends(PlanCardPricePopover, _super);
    function PlanCardPricePopover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlanCardPricePopover.prototype.renderItemRate = function () {
        var _this = this;
        var item = this.props.item;
        if (item instanceof QuoteItemStore_1.QuoteFixedCostItemStore) {
            return (react_1.default.createElement(CurrencyInput_1.default, { label: "Item Price", value: item.rate, onChange: function (value) {
                    item.rate = value;
                }, formatCurrency: function (value) {
                    return _this.quoteCurrencyFormatter.formatWithUserDecimalPreference(value, { round: false });
                }, parseCurrency: this.quoteCurrencyFormatter.parse }));
        }
        if (item instanceof QuoteItemStore_1.QuoteVariableItemStore) {
            return (react_1.default.createElement(VariablesCombobox_1.default, { value: item.rate, onChange: function (variableId) {
                    (0, mobx_1.runInAction)(function () {
                        item.rate = variableId;
                    });
                } }));
        }
    };
    PlanCardPricePopover.prototype.renderBillingSchedule = function () {
        var _this = this;
        var _a = this.props, item = _a.item, onChangeBillingSchedule = _a.onChangeBillingSchedule;
        if (item instanceof QuoteItemStore_1.QuoteFixedCostItemStore || item instanceof QuoteItemStore_1.QuoteVariableItemStore) {
            return (react_1.default.createElement(kaleidoscope_1.Dropdown, { label: "Billing frequency", name: (0, Types_1.isRecurringSchedule)(item.billingSchedule) ? (0, StringManipulater_1.titleCase)(item.billingSchedule.frequency) : "One off", size: kaleidoscope_1.DropdownSize.Medium },
                react_1.default.createElement(kaleidoscope_1.DropdownItem, { name: "One off", onSelect: function () {
                        item.setOneOffSchedule();
                        _this.quoteTelemetry.trackBillingScheduleChange(item.billingSchedule);
                        onChangeBillingSchedule((0, PlanGroupTabs_1.frequencyToSchedule)("one off"));
                    } }),
                Object.values(Types_1.RecurringFrequency).map(function (freq) { return (react_1.default.createElement(kaleidoscope_1.DropdownItem, { key: freq, name: freq, onSelect: function () {
                        item.setRecurringFrequency(freq);
                        _this.quoteTelemetry.trackBillingScheduleChange(item.billingSchedule);
                        onChangeBillingSchedule((0, PlanGroupTabs_1.frequencyToSchedule)(freq));
                    } })); })));
        }
    };
    PlanCardPricePopover.prototype.render = function () {
        var _a = this.props, children = _a.children, onOpenToggle = _a.onOpenToggle;
        return (react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, caret: true, className: c(), onChange: onOpenToggle, button: function (_a) {
                var ref = _a.ref, buttonProps = __rest(_a, ["ref"]);
                return (react_1.default.createElement("button", __assign({ className: c("button"), "aria-label": "Edit item price", ref: ref }, buttonProps), children));
            } },
            this.renderItemRate(),
            this.renderBillingSchedule()));
    };
    var _a, _b;
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_a = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _a : Object)
    ], PlanCardPricePopover.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _b : Object)
    ], PlanCardPricePopover.prototype, "quoteTelemetry", void 0);
    return PlanCardPricePopover;
}(react_1.default.Component));
exports.default = PlanCardPricePopover;
